(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pot-infinite-scroll"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pot-infinite-scroll')) {
  customElements.define('pot-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById(this.dataset.gridId);
      this.status = this.querySelector('[data-infinite-status]');
      this.link = this.querySelector('[data-infinite-next]');
      this.nextUrl = this.dataset.nextUrl || '';
      this.loading = false;
      this.failed = false;
      this.visited = new Set();
      this.onNext = (event) => {
        event.preventDefault();
        this.failed = false;
        this.loadNext();
      };
      if (!this.grid || !this.status) return;
      if (!this.nextUrl) {
        this.finish();
        return;
      }
      if (!('IntersectionObserver' in window)) return;
      if (this.link) {
        this.link.addEventListener('click', this.onNext);
        this.link.hidden = true;
      }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting) && !this.failed) this.loadNext();
      }, { rootMargin: '600px 0px', threshold: 0 });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.link?.removeEventListener('click', this.onNext);
      if (this.grid?.isConnected) this.grid.removeAttribute('aria-busy');
    }

    finish() {
      this.observer?.disconnect();
      this.nextUrl = '';
      this.dataset.nextUrl = '';
      this.status.textContent = this.dataset.done;
      if (this.link) this.link.hidden = true;
    }

    async loadNext() {
      if (this.loading || !this.nextUrl || !this.isConnected) return;
      this.loading = true;
      this.controller = new AbortController();
      this.setAttribute('aria-busy', 'true');
      this.grid.setAttribute('aria-busy', 'true');
      this.status.textContent = this.dataset.loading;
      if (this.link) this.link.hidden = true;
      try {
        const url = new URL(this.nextUrl, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Invalid collection origin');
        url.hash = '';
        url.searchParams.delete('sections');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url.toString(), {
          credentials: 'same-origin',
          signal: this.controller.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Collection request failed');
        const html = await response.text();
        if (!this.isConnected || !this.grid.isConnected) return;
        const nextDocument = new DOMParser().parseFromString(html, 'text/html');
        const incomingGrid = nextDocument.getElementById(this.dataset.gridId);
        const incomingControl = [...nextDocument.querySelectorAll('pot-infinite-scroll')]
          .find((control) => control.dataset.gridId === this.dataset.gridId);
        if (!incomingGrid || !incomingControl) throw new Error('Missing collection grid');
        const existingKeys = new Set([...this.grid.children].map((card) => card.dataset.infiniteKey));
        const fragment = document.createDocumentFragment();
        let added = 0;
        for (const card of incomingGrid.children) {
          const key = card.dataset.infiniteKey;
          if (key && existingKeys.has(key)) continue;
          if (key) existingKeys.add(key);
          const node = document.importNode(card, true);
          node.classList.remove('scroll-trigger--offscreen');
          node.classList.add('scroll-trigger--cancel');
          fragment.append(node);
          added += 1;
        }
        if (!added) throw new Error('No new collection cards');
        this.grid.append(fragment);
        this.dataset.loadedCount = String(this.grid.children.length);
        this.visited.add(this.nextUrl);
        this.nextUrl = incomingControl.dataset.nextUrl || '';
        if (this.visited.has(this.nextUrl)) this.nextUrl = '';
        this.dataset.nextUrl = this.nextUrl;
        if (!this.nextUrl) {
          this.finish();
        } else {
          if (this.link) this.link.href = this.nextUrl;
          this.status.textContent = this.dataset.loaded.replace('__count__', String(added));
          this.observer?.unobserve(this);
          this.observer?.observe(this);
        }
      } catch (error) {
        if (error.name === 'AbortError' || !this.isConnected) return;
        this.failed = true;
        this.status.textContent = this.dataset.error;
        if (this.link) {
          this.link.hidden = false;
          this.link.textContent = this.dataset.retry;
        }
      } finally {
        this.loading = false;
        this.removeAttribute('aria-busy');
        if (this.grid?.isConnected) this.grid.removeAttribute('aria-busy');
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
